import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./login.css";
import Logo from "../../assets/img/svg/logo-blanco-check.svg";
import Candado from "../../assets/img/svg/candado.svg";
import Email from "../../assets/img/svg/personaLogin.svg";
import { UserContext } from "../../context/userContext/UserContext";
import BackgroundVideo from "../../ui/videoBackground/videoBackgrond";
import useConfirmDialog from "../../features/modal/ConfirmDialog";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { setUser } = useContext(UserContext);
  const showDialog = useConfirmDialog();
  const navigate = useNavigate(); // Instancia del hook useNavigate
  const API_URL = process.env.REACT_APP_API_URL || "https://check.gruponxt.com";

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formData = new URLSearchParams();
      formData.append("usuario", email);
      formData.append("contrasena", password);

      await axios.post(`${API_URL}/api/login`, formData, {
        withCredentials: true,
      });

      const userResponse = await axios.get(`${API_URL}/api/usuario`, {
        withCredentials: true,
      });
      setUser(userResponse.data);

      if (userResponse.data) {
        navigate("/check"); // Redirecciona usando useNavigate
      }
    } catch (error) {
      console.error("Error logging in:", error);
      showDialog({
        html: "Los datos ingresados son incorrectos, verifícalos e inténtalo de nuevo",
        icon: "error",
        confirmButtonText: "Ok",
        mostrarCancelar: false,
        showConfirm: false,
        autoClose: 1000,
      });
    }
  };

  return (
    <div className="login-container">
      <BackgroundVideo />
      <form onSubmit={handleSubmit} className="login-form">
        <img className="login-container-img" src={Logo} alt="" />
        <div className="input-container">
          <span className="icon">
            <img src={Email} alt="" />
          </span>
          <input
            type="text"
            placeholder="Usuario"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="input-container">
          <span className="icon">
            <img src={Candado} alt="" />
          </span>
          <input
            type="password"
            placeholder="Contraseña"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit" className="login-button">
          Iniciar Sesión
        </button>
        <div className="login-soporte">
          <p>¿Problemas para iniciar sesión?</p>
          <p className="login-soporte-green">Soporte Técnico</p>
        </div>
      </form>
    </div>
  );
};

export default Login;
